import { post,get,postJson,put} from '../axios'

const RESOURCE_BASE_PATH = '/shopBuyer'


//周期分析
export const periodBuyerCountone = p => get(`${RESOURCE_BASE_PATH}/periodBuyerCount`, p);

//金额分析
export const totalMoneyBuyerCount = p => get(`${RESOURCE_BASE_PATH}/totalMoneyBuyerCount`, p);

//会员等级
export const buyerGradeCount = p => get(`${RESOURCE_BASE_PATH}/buyerGradeCount`, p);

//地域分析
export const areaBuyerCount = p => get(`${RESOURCE_BASE_PATH}/areaBuyerCount`, p);






